import React from 'react';
import { Box, Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { RhColumns, RHTextField } from '../../../../../../dum';
import {
    FIELD_LABELS,
    formatFloat,
    shortLabel,
} from '../../../../../../../helpers';
import { GroupsInput } from './groups/groups-input';
import { KilosInput } from './kilos/kilos-input';
import { OrderProductionMachineInput } from './machine/machine-input';
import { OrderProductionProductInput } from './product/product-input';
import { IOrderProduction } from '../order-production-form';
import { useOrderProductionNamePrefix } from '../order-production-name-prefix.context';

const ARRAY_NAME: keyof IOrderProduction = 'order_production_products';
const GROUP_WEIGHT_FIELD_NAME: keyof IOrderProduction['order_production_products'][number] =
    'group_weight';
const HOURS: keyof IOrderProduction['order_production_products'][number] =
    'hours';

const defaultValue: IOrderProduction['order_production_products'][number] = {
    product: null,
    machine: null,
    kilos: 0,
    groups: 0,
    group_weight: 0,
    hours: 8,
};

export function OrderProductionProductsColumns() {
    const prefix = useOrderProductionNamePrefix();
    const PREFIXED_ARRAY = `${prefix}${ARRAY_NAME}`;

    // Watch the whole product array so the totals recompute live as the user
    // edits any row's kilos/groups. Field values arrive as strings from the
    // text inputs, so coerce with Number() before summing.
    const products =
        (useWatch({ name: PREFIXED_ARRAY }) as
            | IOrderProduction['order_production_products']
            | undefined) || [];

    const totalKilos = products.reduce(
        (sum, product) => sum + (Number(product?.kilos) || 0),
        0,
    );
    const totalGroups = products.reduce(
        (sum, product) => sum + (Number(product?.groups) || 0),
        0,
    );

    return (
        <>
            <RhColumns
            title={'Productos'}
            name={PREFIXED_ARRAY}
            defaultValue={defaultValue}
            items={[
                {
                    cellGrow: 2,
                    getField: (index) => {
                        return <OrderProductionMachineInput index={index} />;
                    },
                },
                {
                    getField: (index) => {
                        return (
                            <RHTextField
                                name={`${PREFIXED_ARRAY}.${index}.${HOURS}`}
                                label={shortLabel(FIELD_LABELS.hours)}
                                disableGutters
                            />
                        );
                    },
                },
                {
                    cellGrow: 3,
                    getField: (index) => {
                        return <OrderProductionProductInput index={index} />;
                    },
                },
                {
                    getField: (index) => {
                        return <GroupsInput index={index} />;
                    },
                },
                {
                    getField: (index) => {
                        return (
                            <RHTextField
                                disabled
                                name={`${PREFIXED_ARRAY}.${index}.${GROUP_WEIGHT_FIELD_NAME}`}
                                label={shortLabel(FIELD_LABELS.group_weight)}
                                disableGutters
                            />
                        );
                    },
                },
                {
                    getField: (index) => {
                        return <KilosInput index={index} />;
                    },
                },
            ]}
            />
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 4,
                    mx: 1,
                    mt: 1,
                }}
            >
                <Typography variant={'subtitle2'}>
                    Total grupos: {formatFloat(totalGroups)}
                </Typography>
                <Typography variant={'subtitle2'}>
                    Total kilos: {formatFloat(totalKilos)}
                </Typography>
            </Box>
        </>
    );
}
